import { Controller } from "@hotwired/stimulus";

/**
 * Domain Menu Controller
 *
 * Manages the collapsible domain menus in the sidebar
 */
export default class extends Controller {
  static targets = ["submenu"];
  static values = {
    activeId: String,
    currentDomain: String,
  };

  connect() {
    // On initial load, collapse all submenus except the current domain (if any)
    this.submenuTargets.forEach((submenu) => {
      const domainId = submenu.dataset.domainId;
      submenu.classList.toggle("hidden", domainId !== this.currentDomainValue);
    });
  }

  toggle(event) {
    event.preventDefault();

    const clickedDomain = event.currentTarget.dataset.domainId;

    // Toggle submenu visibility for the clicked domain
    this.submenuTargets.forEach((submenu) => {
      const domainId = submenu.dataset.domainId;
      if (domainId === clickedDomain) {
        submenu.classList.toggle("hidden");
      } else {
        submenu.classList.add("hidden");
      }
    });
  }
}
